'use client';

import React from 'react';
import { Paper, Title, Text } from '@mantine/core';

interface AuditLogViewerProps {
  filters?: any;
  columns?: string[];
  exportFormats?: string[];
}

export function AuditLogViewer({ filters, columns, exportFormats }: AuditLogViewerProps) {
  return (
    <Paper shadow="sm" radius="md" p="lg">
      <Title order={4}>Audit Log Viewer</Title>
      <Text c="dimmed" size="sm">Audit log viewer coming soon</Text>
    </Paper>
  );
}